/**
 * 容器header
 */
import {mapState} from 'vuex';
import {Pic} from '@/comp';
import {login as api} from '@/api';
import tip from '@/utils/tip';
import {isAdmin, isAgent, isCaptain, isDoc} from '@/utils';

export default {
  name: 'MainHeader',
  data() {
    return {
      websock: null, // 建立的连接
      charId: this.getUuid(), // 随机生成的UUID
      lockReconnect: false, // 是否真正建立连接
      timeout: 28 * 1000, // 30秒一次心跳
      timeoutObj: null, // 心跳心跳倒计时
      serverTimeoutObj: null, // 心跳倒计时
      timeoutnum: null, // 断开 重连倒计时
      lastRunTime: Date.now(), // 上次播放声音的时间
      wsuri: 'wss://127.0.0.1/notice'
    };
  },
  created() {
    if (typeof (WebSocket) === 'undefined') {
      console.log('您的浏览器不支持WebSocket');
    } else {
      // 管理员 和组长 才开通 新消息提醒
      if (this.isAdmin || this.isCaptain) {
        // 页面刚进入时开启长连接
        // this.initWebSocket();
      }
    }
  },
  destroyed: function() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  computed: {
    ...mapState('common', ['userInfo']),
    qrSrc() {
      const {userInfo} = this;
      const {qrcode} = userInfo;
      if (qrcode) {
        let img = new Image();
        img.src = `http://s3.truesight.com.cn/${qrcode}`;
        // img.setAttribute('crossOrigin', 'anonymous');
        // 图片加载完成后触发
        const that = this;
        img.onload = function() {
          let canvas = that.$refs.canvas;

          // 设置画布宽高与图片宽高相同
          let imgWidth = 200;
          let imgHeight = 230;
          canvas.width = imgWidth;
          canvas.height = imgHeight + 65;
          // 获取绘画上下文
          let ctx = canvas.getContext('2d');

          ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

          // 绘制矩形
          ctx.fillStyle = '#ffffff'; // 长方形背景颜色
          ctx.fillRect(0, imgHeight, imgWidth, 65);
          ctx.fillStyle = '#7295CD'; // 长方形背景颜色
          ctx.fillRect(10, imgHeight + 5, imgWidth - 20, 50);

          // 绘制文字
          ctx.font = '12px Calibri'; // 设置文字大小
          ctx.fillStyle = '#ffffff';
          ctx.fillText(that.userInfo.hospitalName, (imgWidth / 2 - (that.userInfo.hospitalName.length * 12) / 2), imgHeight + (12 + 15));

          ctx.font = '12px Calibri'; // 设置文字大小
          ctx.fillText(that.userInfo.departmentName, (imgWidth / 2 - (that.userInfo.departmentName.length * 12) / 2), imgHeight + (12 + 10) * 2);
        };
        return `http://s3.truesight.com.cn/${qrcode}`;
      }
      return '';
    },
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    isCaptain() {
      const {role} = this.userInfo;
      return isCaptain(role);
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
  },
  components: {Pic},
  methods: {
    /**
     * 下载二维码
     */
    saveQrImg() {
      const {hospitalName, departmentName} = this;
      const canvas = this.$refs.canvas;
      const a = document.createElement('a');
      // a.href = canvasData[0].src;
      a.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
      console.log(a.href);
      a.download = hospitalName + '-' + departmentName + '收费.png';
      a.click();
    },

    onLogout() {
      this.$confirm('确认要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api.logout().then((res = {}) => {
          if (res.code === 10000) {
            this.$router.push({name: 'Login'});
          }
        });
      });
    },
    onHelp() {
      this.$alert('这是一段帮助信息', '帮助信息', {
        confirmButtonText: '确定',
        callback: action => {
          //   this.$message({
          //     type: 'info',
          //     message: `action: ${action}`
          //   });
        }
      });
    },
    onNotice: function(msg) {
      const data = JSON.parse(msg);
      // console.log(data);
      // console.log(parseInt(data.type / 10));
      // task 通知
      if (parseInt(data.type / 10) === 1) {
        const info = `【${data.msg}】有一个新订单 <el-link style="color: #00adff">点击打开<el-link/>`;
        this.$notify({
          title: '新订单通知',
          dangerouslyUseHTMLString: true,
          message: info,
          duration: 0,
          onClick: () => {
            this.onOpen(data);
          }
        });
        let audio = new Audio();
        audio.src = '/static/new_msg_3.wav';
        audio.play();
      }
    },
    onOpen(data) {
      const id = data.orderId;
      let name;
      if (data.type === 11) {
        // task待提交
        name = 'OrderUnsubmitDetail';
      } else if (data.type === 12) {
        // task 已提交
        name = 'OrderDetail';
      } else if (data.type === 13) {
        // task 重建中
        name = 'OrderDetail';
      } else if (data.type === 14) {
        // task 重建完成
        name = 'OrderDetail';
      }
      this.$router.push({
        name: name,
        params: {id},
      });
    },

    /***
     * 建立连接
     */
    initWebSocket() {
      // 初始化weosocket
      const {id} = this.userInfo;
      // console.log('id = ' + id);
      if (!id) {
        return;
      }
      // 建立连接
      this.websock = new WebSocket(this.wsuri + '/' + id);
      // 连接成功
      this.websock.onopen = this.websocketonopen;
      // 连接错误
      this.websock.onerror = this.websocketonerror;
      // 接收信息
      this.websock.onmessage = this.websocketonmessage;
      // 连接关闭
      this.websock.onclose = this.websocketclose;
    },
    /**
     * 重新连接
     */
    reconnect() {
      const that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        // 新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    /***
     * 重置心跳
     */
    reset() {
      const that = this;
      // 清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      // 重启心跳
      that.start();
    },
    /***
     * 开启心跳
     */
    start() {
      const self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function() {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState === 1) { // 如果连接正常
          // self.websock.send('heartCheck');
          self.websocketsend('heartCheck');
        } else { // 否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function() {
          // 超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    /**
     * 连接成功事件
     */
    websocketonopen() {
      // 提示成功
      tip.success('连接成功', 3);
      // 开启心跳
      this.start();
    },
    /**
     * 连接失败事件
     * @param e
     */
    websocketonerror(e) {
      // 错误
      console.log('WebSocket连接发生错误');
      // 错误提示
      // tip.error('Websocket error, Check you internet!');
      // 重连
      this.reconnect();
    },
    /**
     * 连接关闭事件
     * @param e
     */
    websocketclose(e) {
      const path = this.$route.path;
      if (path.indexOf('login') > -1 || path.indexOf('findPass') > -1 || path.indexOf('register') > -1) {
        clearInterval(this.timeoutObj);
        // this.websock.close();
        return;
      }
      this.reconnect();
    },
    /***
     * 接收服务器推送的信息
     * @param event
     */
    websocketonmessage(event) {
      // 打印收到服务器的内容
      // console.log(event.data);
      // 心跳检测
      if (event.data === 'heartBack') {
        this.reset();
      } else {
        this.onNotice(event.data);
      }
    },
    /**
     * 向服务器发送信息
     * @param msg
     */
    websocketsend(msg) {
      // 数据发送
      this.websock.send(msg);
    },
    /**
     * @return {string}
     */
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    getUuid() {
      return (this.S4() + this.S4() + '-' + this.S4() + '-' + this.S4() + '-' + this.S4() + '-' + this.S4() + this.S4() + this.S4());
    },
  }
};



// WEBPACK FOOTER //
// ./src/comp/MainHeader/_.js